export const formValidationConstants = {
    dateOfBirthErrorMessage: 'Please enter a valid date of birth.',
    membersMustBeOVer16: 'Members must be 16 or over.',

    minimumValidAge: 16,
    minimumValidMonth: 1,
    maximumValidMonth: 12,

    privacyPolicyErrorMessage: 'You need to agree to our Privacy Policy to continue.',
    oneClubTermsAndServicesErrorMessage: 'You need to agree to our Terms and Services to continue.',

    pleaseInputAValue: 'Please input a value.',
    /* eslint-disable-next-line */
    emailPattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    emailAddressErrorMessage: 'This value should be a valid email.',
    blockedDomainMessage: 'Invalid email address. Please try again with a correct domain',
    confirmEmailErrorMessage: 'The email and the email confirmation should be the same.',

    passwordPattern: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/,
    passwordErrorMessage: 'The password should contain at least one small letter, one capital letter and digit. Minimum password length is 8 characters.',

    confirmPasswordErrorMessage: 'The password and the password confirmation should be the same.',
    newPasswordErrorMessage: 'The password and the new password should not be the same.',
    oldPasswordErrorMessage: 'The new and old password cannot have the same value.',
    none: 'None',

    titleErrorMessage: 'Please select a title.',
    countryErrorMessage: 'Please select your Country.',
    countyErrorMessage: 'Please select your County',
    stateErrorMessage: 'Please select your State',

    venuesErrorMessage: 'Please select venues you are interested in.',
    championshipSectionErrorMessage: 'Please select the championship you are interested in',
    channelSectionErrorMessage: 'Please select the channel you are interested in',
    interestSectionErrorMessage: 'Please select your prefered interests',
    firstNameErrorMessage: 'Please enter your First Name.',
    lastNameErrorMessage: 'Please enter your Last Name.',
    addressLine1ErrorMessage: 'Please enter your Address.',
    postcodeErrorMessage: 'Please enter your Post Code.',
    mobilePhoneErrorMessage: 'Phone number must be between 7 and 15 characters.',
    cityErrorMessage: 'Please enter your City.',
    favoritePlayerErrorMessage: 'Please specify your favorite golf player name.',
    verificationCodeErrorMessage: 'Please input the received verification code.',
    specialCharactersErrorMessage: 'Allowed: \',-.a-z . Please start and finish just with letters.',
    specialCharactersNumbersErrorMessage: 'Allowed: \',-.a-z0-9 . Please start and finish just with letters or numbers.',
    specialCharactersNumbersLettersErrorMessage: 'Allowed: a-z0-9 -. Please start and finish just with letters or numbers.',
    specialCharactersCityErrorMessage: 'Allowed: a-z0-9 \',.&- . Please start and finish just with letters or numbers.',

    captchaInvalidErrorMessage: 'Please let us verify you are not a robot',

    suttonixDomain: '@suttontix',
    ecrypseDomain: '@ecrypse',
    dogpilezDomain: '@dogpilez'
};
